import { useState, useEffect, memo } from "react";
import { DirectionsRenderer } from "@react-google-maps/api";
import { showErrorMessage } from "helpers/toastMessage";

interface DirectionsRendererWrapperProps {
  origin: {
    lat: number;
    lng: number;
  };
  destination: {
    lat: number;
    lng: number;
  };
  directionsService: google.maps.DirectionsService;
}

function DirectionsWrapper({
  origin,
  destination,
  directionsService
}: Readonly<DirectionsRendererWrapperProps>) {
  const [directions, setDirections] = useState<google.maps.DirectionsResult | null>(null);

  useEffect(() => {
    directionsService.route(
      {
        origin,
        destination,
        travelMode: google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          setDirections(result);
        } else {
          showErrorMessage(`Error fetching directions ${result}`);
        }
      }
    );
  }, [origin, destination, directionsService]);

  if (!directions) {
    return null;
  }

  return (
    <DirectionsRenderer
      options={{
        directions: directions,
        preserveViewport: true
      }}
    />
  );
}

export default memo(DirectionsWrapper);
